import(/* webpackMode: "eager", webpackExports: ["HubArticlePage"] */ "/app/src/app/(browse)/hub/guides/[slug]/HubArticlePage.tsx");
